import isEmpty from "lodash/isEmpty";
import { sendGTMEvent } from "../../services/gtmEvents";

export const EVENT_NAME = "appbar-search";

interface ISendSearchGtmEventOptions {
  searchText: string;
}

export function sendSearchGtmEvent({ searchText }: ISendSearchGtmEventOptions): void {
  if (isEmpty(searchText)) {
    return;
  }

  const eventData = {
    event: EVENT_NAME,
    search_term: searchText,
  };

  sendGTMEvent(eventData);
}
